module.exports = __webpack_public_path__ + "static/media/facebook-icon.409dbc6b.svg";